import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );

if( $( '.expanding-section' ).length ) {
  ScrollTriggerInit;

  const section = document.querySelectorAll( '.expanding-section' );

  let mm = gsap.matchMedia();

  mm.add("(min-width: 767px)", () => {
    section.forEach( ( elem ) => {
      ScrollTrigger.create( {
        trigger: elem,
        invalidateOnRefresh: true,
        invalidateOnResize: true,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => $( elem ).addClass( 'active' ),
        onEnterBack: () => $( elem ).addClass( 'active' ),
        onLeave: () => $( elem ).removeClass( 'active' ),
        onLeaveBack: () => $( elem ).removeClass( 'active' ),
        onUpdate: () => ScrollTrigger.refresh(),
      } )
    } )
  });


  $( '.expanding-section .title' ).on( 'click', function(e) {
    e.preventDefault();

    let accordion = $( this ).parent().parent().parent();

    if ( accordion.hasClass( 'active' ) ) {
      accordion.removeClass( 'active' );
    } else {
      accordion.siblings().removeClass( 'active' );
      accordion.addClass( 'active' );
    }
  });
}

if( $( '.page-nav-container' ).length ) {
  ScrollTriggerInit;
  const navLinks = gsap.utils.toArray( '.page-nav' );   
  const panels = gsap.utils.toArray( '.panel' );

  ScrollTrigger.create({
    trigger: '#main-content',
    start: 'top top',
    invalidateOnRefresh: true,
    toggleClass: { targets: '.nav', className: 'nav-lock' },
    onEnter: () => $( '.page-nav-container').addClass( 'fixed' ),
    onEnterBack: () => $( '.page-nav-container').removeClass( 'fixed'  ),
    onLeave: () => $( '.page-nav-container').addClass( 'fixed'  ),
    onLeaveBack: () => $( '.page-nav-container').removeClass( 'fixed'  ),
  });

  panels.forEach( ( elem, i ) => { 
    ScrollTrigger.create( {
      trigger: elem,
      start: 'top 100', 
      end: 'bottom 100',
      invalidateOnRefresh: true,
      toggleClass: {targets: navLinks[i], className: 'active'},
    });
  });
  //recalculate the dom positions of each panel after page load
  setTimeout( () => {
    ScrollTrigger.refresh()
  }, 1000 ) 

  $( '.page-nav' ).on( 'click', function( e ) {
    e.preventDefault();
    var id = $(this).attr( 'href' );
    $( 'html,body' ).animate({ scrollTop: $( id ).offset().top - 85 }, 270 );
  });
}

if (  location.hash && !(location.hash.startsWith( '#!' ))  ){
  var id = $( location.hash );
  
  $( window ).on( 'load', function() {
    setTimeout( () => {
      $( 'html,body' ).animate( { scrollTop: id.offset().top - 100 }, 600 )
    }, 500 )
  });
};

// left out the jquery
let communityMap = document.querySelector( '.communities-filter-section' );

if( communityMap ) {
  
  let communityToggles = document.querySelectorAll( '.community-toggle .tag' );
  let legendCategories = document.querySelectorAll('.map-legend-cat');

    // Function to update visibility based on screen size
    function updateLegendVisibility() {
      let windowWidth = window.innerWidth;
  
      legendCategories.forEach(cat => {
        let city = cat.getAttribute('data-city');
  
        if (windowWidth > 960) {
          cat.style.display = 'block'; // Show all categories over 960px
        } else {
          cat.style.display = city === 'edmonton' ? 'none' : 'block'; // Hide Edmonton by default under 960px
        }
      });
    }
  

    // Listen for window resize
    window.addEventListener('resize', updateLegendVisibility);

  communityToggles.forEach( tag => {

    tag.addEventListener( 'click', function() {
      // remove active from all tags || add active to clicked tag
      communityToggles.forEach( t => t.classList.remove( 'active' ) );
      this.classList.add( 'active' );

      let city = this.getAttribute( 'data-city' );

      // Hide all legend categories
      legendCategories.forEach(cat => cat.style.display = 'none');

      // Show matching legend categories
      document.querySelectorAll(`.map-legend-cat[data-city="${city}"]`)
        .forEach(cat => cat.style.display = 'block');

    });
  });
}